import type { ReactNode } from "react";
import { BookOpen } from "lucide-react";

type DocsLinkProps = {
  href: string;
  children: ReactNode;
};

export function DocsLink({ href, children }: DocsLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors"
    >
      <BookOpen className="h-3.5 w-3.5" aria-hidden />
      {children}
    </a>
  );
}
